import React, {FC, useMemo} from "react";
import ScTable from "@/PageComponents/Table/ScTable";
import {ColumnMappingMetaData, ScTableProps} from "@/PageComponents/Table/table-model";
import {Text} from "@mantine/core";

const JobStatusSummary: FC<{jobId: string}> = ({jobId}: any) => {

    const jobStatusTable = useMemo<ScTableProps>(() => (
        {
            staticColumnMapping: [
                {
                    Sortable: false,
                    ColumnName: 'JobCardStatusDescription',
                    CellType: 'status',
                    Label: 'Status',
                    ID: 'jobCardStatusDescription',
                    MetaData: JSON.stringify({
                        displayColorKeyName: 'JobCardStatusDisplayColor'
                    } as ColumnMappingMetaData)
                },
                {
                    Sortable: false,
                    ColumnName: 'DaysInStatus',
                    Label: 'Days in status',
                    ID: 'daysInStatus',
                },
                {
                    Sortable: false,
                    ColumnName: 'CreatedDate',
                    Label: 'Created',
                    ID: 'createdDate',
                    CellType: 'date',
                },
                {
                    Sortable: false,
                    ColumnName: 'StatusChangedDate',
                    Label: 'Updated',
                    ID: 'statusChangedDate',
                    CellType: 'date',
                },
                {
                    Sortable: false,
                    ColumnName: 'CreatedBy',
                    Label: 'Updated by',
                    ID: 'createdBy',         
                }
            ],
            tableDataEndpoint: '/Job/GetJobStatusChanges',
            tableName: 'jobStatusSummary',
            tableNoun: 'Status',
            tableAltMultipleNoun: 'Statuses',
            /*tableFilterMetaData: {
                options: [
                    {
                        type: 'dateRange',
                        label: 'Start/End Date',
                        filterName: ['StartDate', 'EndDate'],
                    },
                    {
                        type: 'hidden',
                        filterName: 'QueryID',
                        label: "Job Id",
                        defaultValue: jobId
                    },
                ]
            },*/
            tableDataPayloadSingleQueryItemValue: jobId,
            bottomRightSpace: true,
            selectMode: 'none',
            removeFilter: true,
            removePagination: true,
            bypassGlobalState: true
        }
    ), [jobId])


    return (
        <>
            <Text size={'md'} fw={600} my={'md'}>
                {/*<IconHistory size={18} />*/} Job Status Summary
            </Text>
            <ScTable

                {...jobStatusTable}
            />
        </>
    )
}

export default JobStatusSummary
